import { makeStyles } from 'tss-react/mui';
import { teceoGrayFont } from '../../../../../../../../../../Theme';

export const useAlterMessageTypeButtonStyles = makeStyles()((theme) => ({
  button: {
    color: teceoGrayFont,
    [theme.breakpoints.down('sm')]: {
      height: '36px',
    },
  },
  selectedButton: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    backgroundColor: `${theme.palette.primary.main}4D`,
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}66`,
    },
  },
}));
